import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Ar from "../../assets/images/ar.png";
import Eng from "../../assets/images/eng.png";

import {
  Button,
  CartIcon,
  Category,
  Count,
  CounterDiv,
  FavoriteIcon,
  HeaderContainer,
  HeaderContent,
  HeaderRightSide,
  Icon,
  EmptyProfilePhoto,
  Image,
  ProfilePhoto,
  LoaderContainer,
  ProfilePicEmpty,
  LogoGiftIcon,
  StyledHeaderRow,
  Logo,
  LogoRow,
  MenuIcon,
  StyledLogo,
  ChevronDownIcon,
  CategoriesRow,
  StyledCategoriesRow,
} from "./NewHeader.styles";

import { useSelector, useDispatch } from "react-redux";
import {
  selectBusinessUserInfo,
  selectCompanyInfo,
} from "../../store/slices/businessUser/slice";
import {
  selectedLocale,
  setSelectedLocale,
} from "../../store/slices/common/slice";
import i18next from "i18next";
import { SESSION_STORAGE_SELECTED_LOCALE } from "../../utils/constants";
import SignModal from "../Modal/SignModal";
import {
  cartItemsData,
  categoriesData,
  categoriesLoading,
  selectFavoriteItems,
} from "../../store/slices/marketplace/marketplaceSlice";
import SkeletonMarketplaceSortLoader from "../SkeletonLoader/SkeletonMarketplaceSortLoader/SkeletonMarketplaceSortLoader";
import ProfileModal from "../Modal/ProfileModal";
import { selectUserInfo } from "../../store/slices/authRecipient/slice";
import { countClickAction } from "../../store/slices/common/asyncThunks";
import NewSidebarModal from "../Modal/NewSidebarModal";
import NavDropdown from "../CategoryDropdown/CategoryDropdown";

const NewHeader = ({ sendGift, hideCategories }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const userInfo = useSelector(selectUserInfo);
  const { companyLogo } = useSelector(selectCompanyInfo);
  const { loggedIn, fullName, id, role } = useSelector(selectBusinessUserInfo);
  const cartItems = useSelector(cartItemsData);
  const favoriteItems = useSelector(selectFavoriteItems);
  const categories = useSelector(categoriesData);
  const categoriesPending = useSelector(categoriesLoading);

  const locale = useSelector(selectedLocale);
  const ar = locale === "ar";

  const [openSignModal, setOpenSignModal] = useState(false);
  const [openProfileModal, setOpenProfileModal] = useState(false);
  const [openSidebarModal, setOpenSidebarModal] = useState(false);
  const [active, setActive] = useState(false);
  const [isVisible, setIsVisible] = useState(active);

  const queryParams = new URLSearchParams(location.search);
  const selectedId = queryParams.get("category");

  useEffect(() => {
    let timer;
    if (active) {
      setIsVisible(true);
    } else {
      timer = setTimeout(() => setIsVisible(false), 150);
    }

    return () => clearTimeout(timer);
  }, [active]);

  const handleLocaleChange = (locale) => {
    localStorage.setItem(SESSION_STORAGE_SELECTED_LOCALE, locale);
    dispatch(setSelectedLocale(locale));
    i18next.changeLanguage(locale);

    const newPath = location?.search
      ? `/${locale}${location.pathname}${location.search}`
      : `/${locale}${location.pathname}`;
    window.history.replaceState({}, "", newPath);
    window.location.reload();
  };

  const CartCounter = () => {
    if (cartItems?.length > 0) {
      return (
        <CounterDiv $ar={ar}>
          <Count>{cartItems?.length}</Count>
        </CounterDiv>
      );
    } else {
      return null;
    }
  };

  const FavoriteCounter = () => {
    if (favoriteItems?.count > 0) {
      return (
        <CounterDiv $ar={ar}>
          <Count>{favoriteItems?.count}</Count>
        </CounterDiv>
      );
    } else {
      return null;
    }
  };

  const [openActive, setOpenActive] = useState(false);

  return (
    <HeaderContainer $active={active} $hideCategories={hideCategories}>
      <HeaderContent $hideCategories={hideCategories}>
        <StyledHeaderRow>
          <LogoRow>
            <StyledLogo
              onClick={() => {
                navigate("/");
                window.scrollTo(0, 0);
              }}
            />
            {(loggedIn ||
              location.pathname === "/marketplace" ||
              location.pathname === "/admin-portal/marketplace") && (
              <MenuIcon onClick={() => setOpenSidebarModal(true)} />
            )}
          </LogoRow>
          <Logo
            onClick={() => {
              navigate("/");
            }}
          />

          <HeaderRightSide>
            {location.pathname !== "/sign-up/steps/upgrade" && (
              <Button
                onClick={() => {
                  dispatch(countClickAction("giftingAsAService"));
                  if (!loggedIn) {
                    setOpenSignModal(true);
                  } else {
                    navigate("/sign-up/steps/upgrade");
                  }
                }}
              >
                {t("gaas")}
              </Button>
            )}
            <Icon
              onClick={() => {
                if (!loggedIn) {
                  setOpenSignModal(true);
                } else {
                  window.scrollTo(0, 0);
                  navigate("/admin-portal/favorite");
                }
              }}
            >
              <FavoriteIcon />
              <FavoriteCounter />
            </Icon>
            <Icon
              onClick={() => {
                if (!loggedIn) {
                  navigate("/cart");
                } else {
                  window.scrollTo(0, 0);
                  navigate("/admin-portal/cart");
                }
              }}
            >
              <CartIcon />
              <CartCounter />
            </Icon>
            {loggedIn ? (
              companyLogo ? (
                <ProfilePhoto
                  src={companyLogo}
                  alt="profilepicture"
                  onClick={() => {
                    if (!location.pathname.includes("admin-portal")) {
                      setOpenProfileModal(true);
                    } else {
                      if (location.pathname !== "/admin-portal/dashboard") {
                        navigate("/admin-portal/dashboard");
                      }
                    }
                  }}
                />
              ) : (
                <ProfilePicEmpty
                  onClick={() => {
                    if (!location.pathname.includes("admin-portal")) {
                      setOpenProfileModal(true);
                    } else {
                      if (location.pathname !== "/admin-portal/dashboard") {
                        navigate("/admin-portal/dashboard");
                      }
                    }
                  }}
                >
                  <div>
                    <LogoGiftIcon />
                  </div>
                </ProfilePicEmpty>
              )
            ) : (
              <EmptyProfilePhoto
                onClick={() => {
                  setOpenSignModal(true);
                }}
              />
            )}

            {ar ? (
              <Image
                src={Eng}
                alt="English Language"
                onClick={() => handleLocaleChange("en")}
              />
            ) : (
              <Image
                src={Ar}
                alt="Arabic Language"
                onClick={() => handleLocaleChange("ar")}
              />
            )}

            {/* {!hideCategories && (
              <ChevronDownIcon
                $active={active}
                onClick={() => {
                  setActive(!active);
                }}
              />
            )} */}
          </HeaderRightSide>
        </StyledHeaderRow>
        {!hideCategories && (
          <CategoriesRow $flexStart>
            {/* {categoriesPending ? (
            <LoaderContainer>
              <SkeletonMarketplaceSortLoader single />
            </LoaderContainer>
          ) : (
            <Category
              $active={!selectedId && location.pathname.includes("marketplace")}
              onClick={() => {
                window.scrollTo(0, 0);
                if (selectedId !== "") {
                  if (loggedIn) {
                    if (location.pathname.includes("ops-portal")) {
                      navigate(`/ops-portal/marketplace`);
                    } else {
                      navigate(`/admin-portal/marketplace`);
                    }
                  } else {
                    navigate(`/marketplace`);
                  }
                }
              }}
            >
              {t("all")}
            </Category>
          )} */}
            {categoriesPending ? (
              <LoaderContainer>
                <SkeletonMarketplaceSortLoader />
              </LoaderContainer>
            ) : (
              categories?.map((category) => (
                <NavDropdown
                  key={category.id}
                  openActive={openActive}
                  setOpenActive={setOpenActive}
                  label={
                    ar
                      ? t(category.nameAr ? category.nameAr : category.name)
                      : t(category.name)
                  }
                  items={category.subcategories}
                  selectedId={selectedId}
                  red={category.name === "sale"}
                  category={category}
                  ar={ar}
                  onClickCategory={() => {
                    window.scrollTo(0, 0);
                    if (!category?.subcategories?.length) {
                      if (loggedIn) {
                        if (
                          location.pathname.includes("ops-portal") &&
                          location.pathname !==
                            `/ops-portal/marketplace?category=${category.id}`
                        ) {
                          navigate(
                            `/ops-portal/marketplace?category=${category.id}`,
                          );
                        } else {
                          if (
                            location.pathname !==
                            `/admin-portal/marketplace?category=${category.id}`
                          ) {
                            navigate(
                              `/admin-portal/marketplace?category=${category.id}`,
                            );
                          }
                        }
                      } else {
                        if (
                          location.pathname !==
                          `/marketplace?category=${category.id}`
                        ) {
                          navigate(`/marketplace?category=${category.id}`);
                        }
                      }
                    }
                  }}
                  onSelect={(item) => {
                    window.scrollTo(0, 0);
                    if (loggedIn) {
                      if (location.pathname.includes("ops-portal")) {
                        navigate(`/ops-portal/marketplace?category=${item.id}`);
                      } else {
                        navigate(
                          `/admin-portal/marketplace?category=${item.id}`,
                        );
                      }
                    } else {
                      navigate(`/marketplace?category=${item.id}`);
                    }
                  }}
                />
                // <Category
                //   $red={category.name === "sale"}
                //   key={category.id}
                //   $active={
                //     category.id === parseInt(selectedId) &&
                //     location.pathname.includes("marketplace")
                //   }
                //   onClick={() => {
                //     window.scrollTo(0, 0);
                //     if (loggedIn) {
                //       if (
                //         location.pathname.includes("ops-portal") &&
                //         location.pathname !==
                //           `/ops-portal/marketplace?category=${category.id}`
                //       ) {
                //         navigate(
                //           `/ops-portal/marketplace?category=${category.id}`,
                //         );
                //       } else {
                //         if (
                //           location.pathname !==
                //           `/admin-portal/marketplace?category=${category.id}`
                //         ) {
                //           navigate(
                //             `/admin-portal/marketplace?category=${category.id}`,
                //           );
                //         }
                //       }
                //     } else {
                //       if (
                //         location.pathname !==
                //         `/marketplace?category=${category.id}`
                //       ) {
                //         navigate(`/marketplace?category=${category.id}`);
                //       }
                //     }
                //   }}
                // >
                //   {ar
                //     ? t(category.nameAr ? category.nameAr : category.name)
                //     : t(category.name)}
                // </Category>
              ))
            )}
          </CategoriesRow>
        )}
      </HeaderContent>

      <SignModal
        close={() => setOpenSignModal(false)}
        open={openSignModal}
        t={t}
        navigate={navigate}
        ar={ar}
      />
      <ProfileModal
        close={() => setOpenProfileModal(false)}
        open={openProfileModal}
        t={t}
        navigate={navigate}
        recipientId={userInfo.id}
        businessId={id}
        role={role}
        fullName={fullName}
      />
      <NewSidebarModal
        sendGift={sendGift}
        close={() => setOpenSidebarModal(false)}
        open={openSidebarModal}
        t={t}
        ar={ar}
        navigate={navigate}
        recipientId={userInfo.id}
        businessId={id}
        role={role}
        loggedIn={loggedIn}
        pathname={location.pathname}
      />

      {/* {isVisible && ( */}
      {/* // <StyledCategoriesRow $flexStart $active={active}> */}
      {/* {categoriesPending ? (
            <LoaderContainer>
              <SkeletonMarketplaceSortLoader single />
            </LoaderContainer>
          ) : (
            <Category
              $active={
                selectedId === "" && location.pathname.includes("marketplace")
              }
              onClick={() => {
                window.scrollTo(0, 0);
                if (selectedId !== "") {
                  if (loggedIn) {
                    if (location.pathname.includes("ops-portal")) {
                      navigate(`/ops-portal/marketplace`);
                    } else {
                      navigate(`/admin-portal/marketplace`);
                    }
                  } else {
                    navigate(`/marketplace`);
                  }
                }
              }}
            >
              {t("all")}
            </Category>
          )} */}
      {/* {categoriesPending ? (
            <LoaderContainer>
              <SkeletonMarketplaceSortLoader />
            </LoaderContainer>
          ) : (
            categories?.map((category) => (
              <Category
                $red={category.name === "sale"}
                key={category.id}
                $active={
                  parseInt(selectedId) === category.id &&
                  location.pathname.includes("marketplace")
                }
                onClick={() => {
                  window.scrollTo(0, 0);
                  if (loggedIn) {
                    if (
                      location.pathname.includes("ops-portal") &&
                      location.pathname !==
                        `/ops-portal/marketplace?category=${category.id}`
                    ) {
                      navigate(
                        `/ops-portal/marketplace?category=${category.id}`,
                      );
                    } else {
                      if (
                        location.pathname !==
                        `/admin-portal/marketplace?category=${category.id}`
                      ) {
                        navigate(
                          `/admin-portal/marketplace?category=${category.id}`,
                        );
                      }
                    }
                  } else {
                    if (
                      location.pathname !==
                      `/marketplace?category=${category.id}`
                    ) {
                      navigate(`/marketplace?category=${category.id}`);
                    }
                  }
                }}
              >
                {ar
                  ? t(category.nameAr ? category.nameAr : category.name)
                  : t(category.name)}
              </Category>
            ))
          )} */}
      {/* </StyledCategoriesRow> */}
      {/* )} */}
    </HeaderContainer>
  );
};

export default NewHeader;
